import { render, staticRenderFns } from "./ButtonDialog.vue?vue&type=template&id=082981e0&scoped=true"
import script from "./ButtonDialog.vue?vue&type=script&lang=js"
export * from "./ButtonDialog.vue?vue&type=script&lang=js"
import style0 from "./ButtonDialog.vue?vue&type=style&index=0&id=082981e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082981e0",
  null
  
)

export default component.exports